export const GLOBAL_GEOMETRY_TYPES = ['MultiPolygon', 'Polygon'];

// orderdesk related map constants

export const MAX_DISTANCE_BETWEEN_POLYGONS = 200;
